<template>
  <footer class="footer">
    
  </footer>
</template>

<script>

</script>

<style scoped>

</style>